/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

/** Granted permission state value, aligned with Permissions API */
export const PERMISSION_STATE_GRANTED = 'granted';

/** Denied permission state value, aligned with Permissions API */
export const PERMISSION_STATE_DENIED = 'denied';

/** Prompt permission state value, aligned with Permissions API */
export const PERMISSION_STATE_PROMPTED = 'prompt';

/** Containing element where a <video> can be inserted */
export const CONTAINER_ID = 'stream_container';

/** Delay until user is asked to retry */
export const RETRY_DELAY = 20000;

/** URL for DES API */
export const DES_API_URL = 'https://des.digimarc.net/api';

/** Value when a watermark was expected but was not able to be scanned - such as all attempts failed */
export const WATERMARK_CHECK_NOT_SEEN = 'notSeen';
